import React from 'react';
import { Box, Modal, Carousel, Typography } from '@drone-js/core';
import { connect, useSelector } from 'react-redux';
import { Loader } from 'component/common/Loader/Loader';
import ActivityCarousel from 'component/page/deprecatedDetail/DetailCard/ActivityCarousel/ActivityCarousel';
import MosaicComponent from 'component/page/deprecatedDetail/DetailCard/ActivityCarousel/MosaicComponent';
import { mapDispatchToProps, mapStateToProps, Props } from 'component/page/deprecatedDetail/DetailCard/ActivityCarousel/MosaicGallery.selectors';
import { body } from 'core-framework/window/document';
import Portal from 'component/common/Portal/Portal';
import styled from 'styled-components';
import { StringFormatter } from '@agoda/react-handyman';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

const MosaicModal = styled(Modal)`
    padding-left: 0 !important;
    padding-right: 0 !important;
`;

const MosaicGallery: React.FC<Props> = React.memo((props): React.JSX.Element => {
    const [modalState, setModalState] = React.useState({ visible: false, index: 0 });
    const gallerySize = props.screenSize.desktop ? 7 : 5;
    const imagesLength = props.images.length;
    const shouldShowTextOverlay = props.images.length > gallerySize;
    const isLessThanGallerySize = imagesLength < gallerySize;
    const mosaicImages = props.images.filter((image) => image.url && image.url.trim()).slice(0, Math.min(props.images.length, gallerySize));
    const cms = useSelector(selectCmsFromBootstrap);

    if (!props.images || imagesLength === 0) {
        return <Loader element="detail-image-carousel" />;
    }

    const onImageClick = (e: React.MouseEvent, index: number) => {
        props.onImageClick(e, index);
        setModalState({ visible: true, index });
    };

    const onModalClose = () => {
        setModalState({ visible: false, index: 0 });
    };

    return (
        <>
            <Box data-testid="activities-mosaic" m="8" position={undefined}>
                {!props.screenSize.desktop ? (
                    <ActivityCarousel isMosaicEnabled={true} onImageClick={onImageClick} />
                ) : (
                    <MosaicComponent
                        mosaicImages={mosaicImages}
                        onImageClick={onImageClick}
                        shouldShowTextOverlay={shouldShowTextOverlay}
                        isLessThanGallerySize={isLessThanGallerySize}
                    />
                )}
            </Box>
            <Portal container={body}>
                <MosaicModal data-element-name="activities-mosaic-modal-gallery" size="m" visible={modalState.visible} onClose={onModalClose} zIndex={1060}>
                    <Carousel
                        data-element-name="activities-carousel-modal-gallery"
                        display="single"
                        pageButtons="inside"
                        pageControl="below"
                        pageCount="bottom-end"
                        accessibilityLabel={props.cms[276248]}
                        accessibilityPreviousNavLabel={props.cms[130765]}
                        accessibilityNextNavLabel={props.cms[130706]}
                        accessibilityPageNumberLabel={props.cms[152705]}
                        currentCard={modalState.index || 0}
                    >
                        {props.images.map((item, index) => (
                            <div key={index}>
                                <ActivityImage
                                    src={item.url || ''}
                                    maxHeight="60vh"
                                    objectFit="contain"
                                    alt={StringFormatter.format(cms[321481], index + 1, props.images.length)}
                                />
                                <Box px="16">
                                    <Typography variant="caption-default-strong">{item.description || ''}</Typography>
                                </Box>
                            </div>
                        ))}
                    </Carousel>
                </MosaicModal>
            </Portal>
        </>
    );
});

MosaicGallery.displayName = 'MosaicGallery';
export default connect(mapStateToProps, mapDispatchToProps)(MosaicGallery);
